/**
 * Configuration setting to enable OwF grants program by country.
 */ export var OWF_GRANTS_BY_COUNTRY = 'OWF_GRANTS_BY_COUNTRY';
